import React, { Component } from "react";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { PageContext, PathInfo } from "@my-dld/contexts/PageContext";

interface Props {
	title?: string | LocaleValue;
	paths?: PathInfo[];
}

class PageTitle extends Component<Props> {

	static contextType = PageContext;
	context!: React.ContextType<typeof PageContext>;

	render() {
		return <React.Fragment/>;
	}

	componentDidMount(): void {
		this.context.setTitle( this.props.title );
		this.context.setPaths( this.props.paths );
	}

	componentWillUnmount(): void {
		this.context.setTitle( undefined );
		this.context.setPaths( undefined );
	}
}

export default PageTitle;
